var chunkMapping = {
	"85": [
		85
	]
};
var idToExternalAndNameMapping = {
	"85": [
		"default",
		"./App",
		25
	]
};
var idToRemoteMap = {
	"85": [
		{
			"externalType": "script",
			"name": "dashboard",
			"externalModuleId": 25
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}